import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface PageHeaderProps {
    title: string;
    /** Only when it adds real information — restated titles are dropped. */
    subtitle?: string;
    actions?: ReactNode;
    className?: string;
}

// The kit page header. No eyebrow, ever — type does the hierarchy. Reuses the
// existing `septima-screen-header` / `septima-hero` scaffold so it slots into
// the page layout (gradient banner + gutter) identically to the header it
// replaces. `ScreenHeader` is now a thin deprecated wrapper over this.
export default function PageHeader({ title, subtitle, actions, className }: PageHeaderProps) {
    return (
        <div className={cn('septima-screen-header', className)}>
            <section className="septima-hero">
                <div className="min-w-0">
                    <h1>{title}</h1>
                    {subtitle && <p>{subtitle}</p>}
                </div>
                {actions && <div className="septima-hero__actions">{actions}</div>}
            </section>
        </div>
    );
}
